import { formatPrice } from '../data/products';

export const calculateVoucherDiscount = (appliedVoucher: any, subtotal: number, shippingCost: number = 0) => {
  if (!appliedVoucher) return 0;

  // Check min purchase
  const minPurchase = appliedVoucher.conditions?.min_purchase || 0;
  if (subtotal < minPurchase) return 0;

  let discountAmount = 0;
  if (appliedVoucher.type === 'percentage') {
    discountAmount = (subtotal * (appliedVoucher.benefit_data.discount_value || 0)) / 100;
    if (appliedVoucher.benefit_data.max_discount && discountAmount > appliedVoucher.benefit_data.max_discount) {
      discountAmount = appliedVoucher.benefit_data.max_discount;
    }
  } else if (appliedVoucher.type === 'fixed_amount') {
    discountAmount = appliedVoucher.benefit_data.discount_value || 0;
  } else if (appliedVoucher.type === 'free_shipping') {
    discountAmount = shippingCost;
    if (appliedVoucher.benefit_data.max_discount && discountAmount > appliedVoucher.benefit_data.max_discount) {
      discountAmount = appliedVoucher.benefit_data.max_discount;
    }
  }

  return discountAmount;
};
